<template>
  <div quick-link-item :class="type">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'QuickLinkItem',
  props: ['type'],
};
</script>

<style lang="less">
@import "~@/less/proj";

[quick-link-item] {
  .rel;
  .w(50%);
  background: #0777ff;
  transition: background-color 1s;

  a {
    .block;
    .p(20);
    .h(140);
    .-box;
    color: #fff;
    .fs(22);
    .lh(32);
    .calibre;
    .medium;

    &:after {
      .cnt;
      .abs;
      .rb(25, 25);
      .wh(25);
      .contain('@{common}/quick-link-arrow.svg');
    }

    &.launch:after {
      .cnt;
      .abs;
      .rb(25, 25);
      .wh(25);
      .contain('@{common}/ico-launch.svg');
    }
  }

  &.gray {
    background: #373d42;
  }

  .no-touch &:hover {
    background-color: #044ada;
  }

  .no-touch &.gray:hover {
    background-color: #878d96;
  }

  &.is-disabled {
    background: #373d42;

    &:hover {
      background: #373d42;
    }

    a {
      pointer-events: none;
      opacity: .2;
    }
  }
}

@media (min-width: @screen-lg-min) {
  [quick-link-item] {
    a {
      .h(140);
    }
  }
}
</style>
